import styled from 'styled-components';

export const CategoryFooterStyled = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;
